const intro = (
  <p>
    Baza <strong>Wideo</strong> na Remedium to miejsce, w którym znajdziesz
    wszystkie materiały, jakie zostały dotychczas nagrane i opublikowane na
    platformie. Wszystkie treści są dostępne w formie nagrania zarówno w
    przeglądarce, jak i w aplikacji.
  </p>
);

const content = (
  <>
    <h3>Wideo na Remedium</h3>
    <p>
      Wspieramy lekarzy i lekarki z całej Polski w zakresie edukacji medycznej.
      Przygotowujemy liczne <strong>webinary</strong> stanowiące bezpośrednie
      źródło rzetelnej wiedzy, które są cennymi szkoleniami online. W wolnym
      czasie medycy mogą zapoznać się z <strong>seriami</strong>, w skład
      których wchodzą formy <strong>podcastowe</strong>. Przygotowaliśmy też{" "}
      <strong>nagrania</strong>, w ramach których udostępniamy zapisy z ważnych
      w świecie medycyny wydarzeń – konferencji czy zjazdów.
    </p>
    <h3>Medyczne nagrania</h3>
    <p>
      Na tej podstronie udostępnione są wszystkie{" "}
      <strong>
        webinary, wydarzenia, szkolenia, konferencje, serie, podcasty
      </strong>{" "}
      (w tym “Medyczne espresso”, “Swoją Drogą”, “5 minut o leku” czy też “Hot
      takes in”), których zapisy kiedykolwiek powstały.
    </p>
  </>
);

export const videoDescription = { intro, content };
